export default __webpack_public_path__ + "static/media/Logo_Low.0fe32ea1.png";